class ContentAccordion extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.header = this.querySelector('header');
    this.content = this.querySelector('main');

    this.header.addEventListener('click', (ev) => {
      this.parentNode.querySelectorAll('content-accordion').forEach((accordion) => {
        if (accordion !== this) {
          accordion.close();
        }
      });

      this.isOpen ? this.close() : this.open();
    });
  }

  connectedCallback() {
    if (this === this.parentNode.firstElementChild) {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.content.classList.remove('hidden');
    this.content.classList.add('flex');
    this.header.querySelector('svg:first-of-type').classList.add('hidden');
    this.header.querySelector('svg:last-of-type').classList.remove('hidden');
    this.header.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'true');
  }

  close() {
    this.isOpen = false;
    this.content.classList.add('hidden');
    this.content.classList.remove('flex');
    this.header.querySelector('svg:first-of-type').classList.remove('hidden');
    this.header.querySelector('svg:last-of-type').classList.add('hidden');
    this.header.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('content-accordion', ContentAccordion);
